import { useTranslation } from "react-i18next"

import {
  InfoField,
  instrumentInfo,
  InstrumentInfoDataPoint,
  QuoteDataPoint,
  QuoteDataPointField,
} from "@/App/Equities/shared/components"
import { Instrument } from "@/App/Equities/shared/services/TradingGateway"
import { Stack } from "@/generated/material"

interface Props {
  symbol: string
}

export const InstrumentDetails = ({ symbol }: Props) => {
  const { t } = useTranslation()

  return (
    <Stack direction="column" paddingX="lg" gap="xl">
      {instrumentInfo.map((info) => {
        const { labelKey, type, field } = info

        return (
          <InfoField
            label={t(labelKey)}
            labelVariant="Text lg/Semibold"
            key={field}
            testId={field}
          >
            {type === "quote" && (
              <QuoteDataPoint
                field={field as QuoteDataPointField}
                symbol={symbol}
              />
            )}

            {type === "instrumentInfo" && (
              <InstrumentInfoDataPoint
                field={field as keyof Omit<Instrument, "tradable">}
                symbol={symbol}
                formatter={info.formatter}
              />
            )}
          </InfoField>
        )
      })}
    </Stack>
  )
}
